import { Checkbox, Col, ConfigProvider, Layout, Row, notification, DatePicker, Flex, Button, Input, Table, Modal, Drawer, Tabs, Skeleton } from "antd";
import { approveFWATrips, cancelFWATrips, getFWASources, getFwaTrips } from "../../service/httpsCalls";
import { useEffect, useState, useRef } from "react";
import { Select, Divider } from 'antd';
import { PlusOutlined, SearchOutlined, EyeOutlined } from "@ant-design/icons";
import dayjs, { Dayjs, extend } from "dayjs";
import { SorterResult, TableRowSelection } from "antd/es/table/interface";
import type { MenuProps, TableColumnsType, TableProps } from 'antd';
import { LoaderSpinner } from "../../components/common/Loader";
import { ColumnDropdown } from "../../components/common/ColumnDropdown";
import debounce from "lodash.debounce";
 import AddNote from "../../components/common/AddNote";
import https from '../../service/httpsService';

const { confirm } = Modal;
const { RangePicker } = DatePicker;
const { Option } = Select;

interface CheckedProps {
    item: string;
    checked: boolean;
}

type NotificationType = 'success' | 'info' | 'warning' | 'error';
export default function FWATrips() {
    const [api, contextHolder] = notification.useNotification();
    const [tableHeight, setTableHeight] = useState(500); // Adjust as needed
    const [tripList, setTripList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [sortedInfo, setSortedInfo] = useState<SorterResult<any>>({ order: 'ascend', field: "dateOfService" });
    const [menuVisible, setMenuVisible] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [selectedTrips, setSelectedTrips] = useState<React.Key[]>([]);
    const parentRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const formRef = useRef(); // Ref to access child component methods
    const [noteReasons, setNoteReasons] = useState([]);
    const [selectedAction, setAction] = useState<string | any>('');
    const baseUrl = window.localStorage.getItem("Referrer");

    //Filter
    const [status, setStatus] = useState<any | null>('all');
    const [sourceTag, setSourceTag] = useState<any | null>(null);
    const [sourceList, setSourceList] = useState([]);
    const [startDate, setStartDate] = useState<string | any>('');
    const [endDate, setEndDate] = useState<string | any>('');
    const [memberId, setMemberId] = useState<string>();
        //create Invoice


    const openNotificationWithIcon = (type: NotificationType, message: string, description: string) => {
        api[type]({
            message: message,
            description: description
        });
    };
    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });

    const columns: TableColumnsType<any> = [
        
        {
            title: 'Trip Id',
            dataIndex: 'tripId',
            sorter: true
        },
        {
            title: 'Date Of Service',
            dataIndex: 'dateOfService',
            render: (text) => dayjs(text).format('MM/DD/YYYY'),
            sorter: true,
            defaultSortOrder: 'ascend'
        },
        {
            title: 'Member Id',
            dataIndex: 'memberId',
            sorter: true
        },
        {
            title: 'Name',
            dataIndex: 'name',
            sorter: true
        },
        {
            title: 'Level Of Service',
            dataIndex: 'levelOfService',
            sorter: true
        },
        {
            title: 'Source',
            dataIndex: 'sourceTag',
            sorter: true
        },
        {
            title: 'Status',
            dataIndex: 'status',
            sorter: true
        },
        {
            title: 'Reservation Note',
            dataIndex: 'notes',
            sorter: false,
            render: (text, record) => (
                text && text.length > 20 ?
                    <span title={text}>{text.toString().substring(0, 20) + '...'}</span> : text
            )
        },
        {
            title: 'Channel',
            dataIndex: 'channel',
            sorter: true
        },
        {
            title: 'View',
            dataIndex: 'tripId',
            render: (text, record) => (
                <Button onClick={() => viewTrip(record)} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                    <EyeOutlined />
                </Button>
            )
        }
    ];

    const [isChecked, setChecked] = useState<CheckedProps[]>(
        columns.map((entry: any) => ({ item: entry.title, checked: !entry.hidden }))
    );

    const fwaColumns = columns.map((item) => ({
        ...item,
        hidden: !isChecked.find(x => x.item === item.title)?.checked,
    }));

    const viewTrip = (rec) => {
        const baseUrl = window.localStorage.getItem("Referrer");
        const rawTripId = rec.tripId.replace("CTC-", ""); // Remove "CTC-" prefix
        const url = baseUrl + '/Reservation/Reservation/Detail/' + btoa(rawTripId);
        window.open(url, "_blank", "noreferrer");
    };

    

    const onSelectChange = (newSelectedTripKeys: React.Key[], selectedRows: any[]) => {
        setSelectedTrips(newSelectedTripKeys);
    };

    const rowSelection: TableRowSelection<any> = {
        selectedRowKeys: selectedTrips,
        onChange: debounce(onSelectChange, 300),
        fixed: 'left',
        getCheckboxProps: (record) => ({
            disabled: record.status?.toLowerCase() != 'pending' // Disable based on condition
        })
    };
    function getTrips(reset?: boolean) {
        setLoading(true);
        setTripList([]);
        getFwaTrips({
            "pageIndex": reset? 1 : currentPage,
            "pageSize": pageSize,
            "sortField": sortedInfo.order ? sortedInfo.field : null,
            "sortDescending": sortedInfo.order == 'descend',
            "memberId": reset? null: (memberId ?? null),
            "fromDOS": reset ? null: (startDate && startDate != '' ? dayjs(startDate).format('MM/DD/YYYY') : null),
            "toDOS": reset ? null : (endDate && endDate != '' ? dayjs(endDate).format('MM/DD/YYYY') : null),
            "status": reset? 'all': (status ?? null),
            "sourceTag": reset? null : (sourceTag ?? null)
        }, (res) => {
            setSelectedTrips([]);
            if (res !== 'error') {
                !showTable && setShowTable(true);
                setTripList(res.items);
                setLoading(false)
                setTotalPages(Math.ceil(res.totalRecords / (pageSize / pageSize)));
            } else {
                setTripList([]);
                setLoading(false)
                setTotalPages(1);
            }
        });
    }
    function search() {
        if (!status && !memberId && !startDate && !sourceTag) {
            return;
        }
        if (pageSize == 0) {
            setPageSize(20);
        } else {
            currentPage == 1 ? getTrips() : setCurrentPage(1);
        }
    }

    function getSources() {
        getFWASources((res) => {
            setSourceList(res);
        })
    }

    useEffect(() => {
        getTrips();
        getSources();
        document.title = "FWA Trips";
        const updateHeight = () => {
            if (parentRef.current) {
                const parentHeight = parentRef?.current?.clientHeight;
                setTableHeight(parentHeight - 110); // Adjust height dynamically
            }
        };
        setTimeout(() => {
            updateHeight();
        }, 500)
        window.addEventListener("resize", updateHeight);
        return () => window.removeEventListener("resize", updateHeight);
    }, []);


    useEffect(() => {
        if (pageSize != 0) {
           getTrips();
        }
    }, [currentPage, pageSize, sortedInfo]);

    const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
        setCurrentPage(pagination.current ?? 1);
        setPageSize(pagination.pageSize ?? 20);
        setTotalPages(pagination.total ?? 100);
        setSortedInfo(sorter as SorterResult<any>);
    };

    const approveSelectedTrips = (noteData) => {
        approveFWATrips({
             tripId: selectedTrips.join(','),
            reason: 'Approved',
            noteText: noteData.noteText
        }, (res) => {
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                openNotificationWithIcon("error", errorMsg, "");
            } else {
                const successMsg = selectedTrips?.length > 1 ? "Trips approved successfully!" : "Trip approved successfully!";
                openNotificationWithIcon("success", successMsg, "");
                getTrips();
            }
        });
    }

    const cancelSelectedTrips = (noteData) => {
        setLoading(true);
        cancelFWATrips({
            tripId: selectedTrips.join(','),
            reason: noteData.noteReason,
            noteText: noteData.noteText
        }, (res) => {
            setLoading(false);
            if (res?.hasError) {
                const errorMsg = res?.error?.messages?.length > 0 ? res.error?.messages[0].description : 'Something went wrong!!!'
                openNotificationWithIcon("error", errorMsg, "");
            } else {
                const successMsg = selectedTrips?.length > 1 ? "Trips denied successfully!" : "Trip denied successfully!";
                openNotificationWithIcon("success", successMsg, "");
                getTrips();
            }

        });
    };


    function resetFilters() {
        setSourceTag(null);
        setStatus('all');
        setMemberId('');
        setStartDate('');
        setEndDate('');
        setTimeout(() => {
            currentPage == 1 ? getTrips(true) : setCurrentPage(1);
        }, 500)
    }

    const showModal = (isApprove: boolean) => {
        if (isApprove) {
            confirm({
                title: 'Do you want to approve selected trips?',
                cancelText: "No",
                okText: "Yes",
                onOk() {
                    setAction("approve");
                    setIsModalOpen(true);
                },
                onCancel() { },
            });
        } else {
            confirm({
                title: 'Do you want to cancel selected trips?',
                cancelText: "No",
                okText: "Yes",
                onOk() {
                    setAction("deny");
                    if (noteReasons?.length) {
                        setIsModalOpen(true);
                    } else {
                        https.get("api/v1/Trips/GetDenialReasons").then((response) => {
                            return response.data
                        }).then((data) => {
                                setNoteReasons(data);
                        }).catch((reason) => { });
                    }
                },
                onCancel() { },
            });
        }
    };

    useEffect(() => {
        if (noteReasons?.length)
            setIsModalOpen(true);
    },[noteReasons])

    const handleOk = () => {
        if (formRef.current) {
            const { noteText, noteReason } = formRef.current;

            if (selectedAction === 'approve') {
                approveSelectedTrips({ noteText });
            } else if (selectedAction === 'deny') {
                cancelSelectedTrips({
                    noteText,
                    noteReason: noteReason?.name ?? '' // 
                });
            }

            setAction('');
            setIsModalOpen(false);
        }
    };


    const handleCancel = () => {
        setIsModalOpen(false);
        setAction('');
    };

    return <ConfigProvider theme={{
        components: {
            Layout: { bodyBg: "#eff1f5", siderBg: "#fff" }
        }
    }} >
        {contextHolder}
        <Layout style={{
            padding: '20px',
            marginBottom: '5px',
            marginTop: '5px',
        }}>
            <Modal
                title="Add Note"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                destroyOnClose={true}
            >
               <AddNote ref={formRef} reasons={noteReasons} hideReasons={selectedAction == 'approve'} />
            </Modal>
            <h3 style={{ textTransform: 'uppercase', marginTop: '0px' }}>FWA Trips</h3>
            <Row type="flex" style={{ padding: '1rem', background: '#fff' }}>
                <Col span={6}>
                    <Input value={memberId} placeholder="Member Id" style={{ width: '90%' }} allowClear onChange={(e) => setMemberId(e?.target?.value)} />
                </Col>
                <Col span={6}>
                    <Select
                        style={{ width: '90%' }}
                        placeholder="Select a Status"
                        onChange={(e) => setStatus(e)}
                        value={status}
                    >
                        <Option key="all">All</Option>
                        <Option key="pending">Pending</Option>
                        <Option key="approved">Approved</Option>
                        <Option key="denied">Denied</Option>
                    </Select>
                </Col>
                <Col span={12}>
                    <RangePicker
                        placeholder={["From DOS", "To DOS"]}
                        style={{ width: '100%' }}
                        format="MM/DD/YYYY"
                        value={[startDate, endDate]}
                        onChange={(dates: any) => {
                            if (dates) {
                                setStartDate(dates[0]);
                                setEndDate(dates[1]);
                            } else {
                                setStartDate('');
                                setEndDate('');
                            }
                        }}
                    />
                </Col>
            </Row>
            <Row type="flex" style={{ padding: '1rem', paddingTop: "0px", background: '#fff' }}>
                <Col span={6}>
                    <Select
                        style={{ width: '90%' }}
                        placeholder="Select a Source"
                        onChange={(e) => setSourceTag(e)}
                        value={sourceTag}
                        allowClear
                    >

                        {Array.isArray(sourceList) && sourceList.map(item => (
                            <Option key={item}>{item}</Option>
                        ))}

                    </Select>
                </Col>                
            </Row>
            <Flex justify='end' style={{ marginBottom: "2rem", padding: "1rem", paddingTop: "0px", background: '#fff' }} gap='small'>
                <Button onClick={search} loading={loading} style={{ marginLeft: '5px' }} type="primary">
                    Search
                </Button>
                <Button onClick={resetFilters} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', marginLeft: '5px', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                    Reset
                </Button>
            </Flex>
            {
                tripList?.length > 0 &&
                <Flex justify="space-between" style={{ padding: "5px", alignItems: "center", background: '#fff' }} gap='small'>
                        <div style={{ background: '#e6f4ff', padding: '0px, 5px', fontWeight: 500 }}>
                            <span style={{ marginRight: '5px', marginLeft: '5px' }}>
                            Selected: {selectedTrips.length}
                        </span>
                    </div>
                    <div>
                            <Button key="approveTrips" style={{ background: '#1677ff', color: '#fff' }} onClick={e=> showModal(true) } disabled={!selectedTrips.length}>
                            Approve
                        </Button>
                            <Button key="cancelUpdate" onClick={e => showModal(false)} disabled={!selectedTrips.length} style={{ marginLeft: '5px', backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }}>
                            Deny
                        </Button>
                    </div>
                </Flex>
            }
            <ColumnDropdown columns={columns} menuVisible={menuVisible} position={position} isChecked={isChecked} setChecked={setChecked} />
            {showTable &&
                <div ref={parentRef} id="table-container" style={{ height: "calc(100vh - 350px)", overflow: "hidden" }}>
                    <Table style={{ background: "#fff" }}
                        scroll={{
                            y: tableHeight
                    }}
                    dataSource={tripList}
                    pagination={{
                        defaultCurrent: 1,
                        current: currentPage,
                        pageSize: pageSize,
                        total: totalPages,
                        showTotal: (total, range) => `${range[0] || 0}-${range[1] || 1} of ${total} items`,
                        showSizeChanger: true,
                    }}
                    rowSelection={rowSelection}
                    columns={fwaColumns}
                    onChange={handleTableChange}
                    size="small"
                    rowKey="tripId"
                    loading={{ indicator: <LoaderSpinner size={24} topMargin="10px" />, spinning: loading }}
                    onHeaderRow={(columns, index) => {
                        return {
                            onContextMenu: (event) => {
                                event.preventDefault();
                                if (!menuVisible) {
                                    document.addEventListener(`click`, function onClickOutside() {
                                        setMenuVisible(false);
                                        document.removeEventListener(`click`, onClickOutside);
                                    });
                                }
                                setMenuVisible(true);
                                setPosition({ x: event.clientX, y: event.clientY });
                            }
                        };
                    }}
                    />
                </div>
            }
        </Layout>
    </ConfigProvider>
}